import axios from "../../axios/axios";
import { CenovaPonuka } from "../../ts/CP";
import {
  TEditCenovaPonukaBody,
  TEditCenovaPonukaState,
  TExportCenovePonukyQuery,
  TGetCenovaPonukaWithIndexQuery,
  TGetFilteredCenovePonukyQuery,
} from "../../types/server-api/cenova-ponuka";
import {
  IGenericResponse,
  ILazyResultResponse,
} from "../../types/server-api/common";

import { APIRoutes } from "../server-api/routes";

type TGetCenovaPonukaWithIndexResult = {
  cenovaPonuka: CenovaPonuka;
  totalCount: number;
  index: number;
};

export interface ICenovaPonukaModel {
  getFilteredCenovePonuky(
    query: TGetFilteredCenovePonukyQuery
  ): Promise<ILazyResultResponse<CenovaPonuka[]>>;
  getCenovaPonukaWithIndex(
    query: TGetCenovaPonukaWithIndexQuery
  ): Promise<TGetCenovaPonukaWithIndexResult>;
  getNewCenovaPonukaId(): Promise<string>;
  editCenovaPonuka(body: TEditCenovaPonukaBody): Promise<IGenericResponse>;
  editCenovaPonukaState(
    body: TEditCenovaPonukaState
  ): Promise<IGenericResponse>;
  createCenovaPonukaCopy(body: TEditCenovaPonukaBody): Promise<CenovaPonuka>;
  createCenovaPonuka(body: TEditCenovaPonukaBody): Promise<CenovaPonuka>;
  deleteCenovaPonuka(body: TEditCenovaPonukaBody): Promise<IGenericResponse>;
  exportCenovePonuky(body: TExportCenovePonukyQuery): Promise<Blob>;
}

export const cenovaPonukaModel: ICenovaPonukaModel = {
  getFilteredCenovePonuky: async (params) => {
    const res = await axios.get<ILazyResultResponse<CenovaPonuka[]>>(
      APIRoutes.CenovaPonuka.GetFiltered,
      {
        params,
      }
    );

    return res.data;
  },
  getCenovaPonukaWithIndex: async (params) => {
    const res = await axios.get<TGetCenovaPonukaWithIndexResult>(
      APIRoutes.CenovaPonuka.GetWithIndex,
      {
        params,
      }
    );

    return res.data;
  },
  getNewCenovaPonukaId: async () => {
    const res = await axios.get<string>(APIRoutes.CenovaPonuka.GetNew);

    return res.data;
  },
  editCenovaPonuka: async (data) => {
    const res = await axios.post<IGenericResponse>(
      APIRoutes.CenovaPonuka.Edit,
      data
    );

    return res.data;
  },
  editCenovaPonukaState: async (data) => {
    const res = await axios.post<IGenericResponse>(
      APIRoutes.CenovaPonuka.EditState,
      data
    );

    return res.data;
  },
  createCenovaPonukaCopy: async (data) => {
    const res = await axios.post<CenovaPonuka>(
      APIRoutes.CenovaPonuka.CreateCopy,
      data
    );

    return res.data;
  },
  createCenovaPonuka: async (data) => {
    const res = await axios.post<CenovaPonuka>(
      APIRoutes.CenovaPonuka.Create,
      data
    );

    return res.data;
  },
  deleteCenovaPonuka: async (data) => {
    const res = await axios.post<IGenericResponse>(
      APIRoutes.CenovaPonuka.Delete,
      data
    );

    return res.data;
  },
  exportCenovePonuky: async (data) => {
    const res = await axios.post<Blob>(APIRoutes.CenovaPonuka.Export, data, {
      responseType: "blob",
    });

    return res.data;
  },
};
